"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("core/utils");
const React = __importStar(require("react"));
class LoginError extends React.Component {
    redirect = () => {
        let { protocol, hostname, port } = window.location;
        if (port === '80' || port === '443') {
            port = '';
        }
        else {
            port = ':' + port;
        }
        (0, utils_1.redirectToLogin)(true, protocol + '//' + hostname + port + '/settings/profile');
    };
    render() {
        return (React.createElement("div", null,
            React.createElement("header", { className: "Header", "data-ui": "account" },
                React.createElement("div", { className: "Header-container Grid u-flexAlignItemsCenter" },
                    React.createElement("div", { className: "Grid-cell u-xs-size1of2" },
                        React.createElement("div", { className: "Header-banner Grid u-flexAlignItemsCenter" },
                            React.createElement("div", { className: "Grid-cell u-sizeFit" },
                                React.createElement("span", { className: "Header-bannerLogo" },
                                    React.createElement("img", { alt: "TeamSnap Logo", src: "https://storage.googleapis.com/ts_assets_prod-classic_assets/logo-default-82d2b864bc99c55657a7042d85cad358.png " }))),
                            React.createElement("div", { className: "Grid-cell u-sizeFill" },
                                React.createElement("h1", { className: "Header-bannerTitle" }, "Log In Error")))))),
            React.createElement("div", { style: { textAlign: 'center' } },
                React.createElement("br", null),
                React.createElement("h1", null, "Looks like you don't have an SSO cookie!"),
                React.createElement("a", { onClick: this.redirect },
                    React.createElement("h3", null, "Click here to login")))));
    }
}
exports.default = LoginError;
